import { Checkbox, styled } from '@mui/material';

export const StyledCheckbox = styled(Checkbox)`
  padding: 0;
`;
